module.exports = __webpack_public_path__ + "assets/ic_keep.6340aeb5.svg";